import ImageMagickState, { initialState } from './State';

import {
  LOADED_IMAGEMAGICK,
  LOADING_IMAGEMAGICK,
  LOAD_IMAGEMAGICK_FAILED,
  ImageMagickAction
} from './Actions';

export default function imageMagickReducer(state = initialState, action: ImageMagickAction): ImageMagickState {
  switch (action.type) {
    case LOADED_IMAGEMAGICK:
      return {
        loaded: true,
        loading: false,
        failed: false
      };
    case LOADING_IMAGEMAGICK:
      return {
        loading: true,
        loaded: false,
        failed: false
      };
    case LOAD_IMAGEMAGICK_FAILED:
      return {
        loading: false,
        loaded: false,
        failed: true
      };
    default:
      return state;
  }
}
